import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import Checkbox from 'aquilla/core/atoms/Checkbox';
import { ALL } from './constants';

const Container = styled.div<{ $hasAllOption: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_3B};
  color: var(--color-text-primary);
  font-size: ${Fonts.H6};
  flex-wrap: wrap;
  ${mediaQuery.uptoMobile} {
    & .aquilla-typography {
      font-weight: ${Fonts.SEMIBOLD};
    }
    span {
      min-width: ${Spacings.SPACING_5B};
    }
    gap: ${Spacings.SPACING_7B};
    & > *:nth-child(2) {
      margin-top: ${({ $hasAllOption }) =>
        $hasAllOption && `-${Spacings.SPACING_10}`};
    }
  }
`;

const StraightLine = styled.div`
  border: 0.5px solid var(--color-i-divider);
  margin-top: ${Spacings.SPACING_14};
  margin-right: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_18};
  }
`;
const CheckBox = ({ options, selected, filterName, onChange, filterType }) => {
  const isChecked = (value) => selected?.includes(value);
  const hasAllOption = !!options.find((option) => option.code === ALL);
  return (
    <>
      <Container $hasAllOption={hasAllOption}>
        {options.map((option) => (
          <div key={option.code}>
            <Checkbox
              isChecked={isChecked(option.code)}
              onChange={() =>
                onChange({ value: option.code, filterName, filterType })
              }
            >
              {option.label}
            </Checkbox>
            {option.code === ALL ? <StraightLine /> : null}
          </div>
        ))}
      </Container>
    </>
  );
};
export default CheckBox;
